import React from 'react';

const AppModalWidget = {
    active: false,
    wrapper: null,
    content: null,
    layoutDiv: null,
    html: $('html'),
    animTimer: 310,
    isAnim: false,
    prevOptions: null,
    prevPlaceEl: null,

    show(options = {}) {
        options = Object.assign(this.getDefaultOptions(), options);
        this.prevOptions = options;

        if (this.active && !options.fromLightClose) {
            this.lightClose(() => {
                options.fromLightClose = true;
                this.show(options);
            });
            return false;
        }

        if (!this.active) {
            this.wrapper = $('<div class="appModalWidget_wrapper"></div>');
            this.layoutDiv = $('<div />');
            this.content = $('<div class="appModalWidget_mainBlock"></div>');
            if (options.wrapContentClass) {
                this.content.addClass(options.wrapContentClass);
            }
            this.content.click((e) => {
                e.stopPropagation();
                e.stopImmediatePropagation();
            });
            this.wrapper.click((e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.prevOptions.closeOnBgClick) {
                    this.close();
                }
            });

            this.layoutDiv.append(this.content);
            this.wrapper.append(this.layoutDiv);
            this.html.find('body').append(this.wrapper);
        }

        this.layoutDiv.removeAttr('class');
        if (options.wrapClass) {
            this.layoutDiv.addClass(options.wrapClass);
        }
        this.content.css(options.css);
        this.content.html('');
        if (options.el) {
            this.prevPlaceEl = options.el.parent();
            this.content.append(options.el);
        }
        this.html.addClass('appModalWidgetLock');

        setTimeout(() => {
            if (typeof options.beforeShow === 'function') {
                options.beforeShow();
                this.content.find('.jsCloseModal').click((e) => {
                    e.preventDefault();
                    this.close();
                });
            }
            if (!options.fromLightClose) {
                this.wrapper.addClass('active');
                this.active = true;
            }

            setTimeout(() => {
                if (typeof options.afterShow === 'function') {
                    options.afterShow();
                }
            }, this.animTimer);
        }, 20);
    },

    lightClose(cb) {
        if (this.prevOptions.el && React.isValidElement(this.prevOptions.el)) {
            ReactDOM.unmountComponentAtNode(this.content[0]);
        }
        if (typeof cb === 'function') {
            cb();
        }
    },

    close(cb) {
        if (this.active) {
            this.wrapper.removeClass('active');
            setTimeout(() => {
                this.html.removeClass('appModalWidgetLock');
                if (this.prevPlaceEl && this.prevPlaceEl.length) {
                    this.prevPlaceEl.append(this.prevOptions.el);
                }
                this.active = false;
                this.content.remove();
                this.layoutDiv.remove();
                this.wrapper.remove();

                if (typeof cb === 'function') {
                    cb();
                }
            }, this.animTimer);
        }
    },

    getDefaultOptions() {
        return {
            el: null,
            wrapClass: '',
            wrapContentClass: '',
            title: '',
            beforeShow: () => { },
            afterShow: () => { },
            css: {},
            closeOnBgClick: false,
            fromLightClose: false,
            withCloseButton: true,
        };
    }
};

export default AppModalWidget;